import { Waypoint } from 'react-waypoint';
import { serverSide } from 'libs/utils/environment';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const THRESHOLD = -600;
const TOP_THRESHOLD = -9999;

const InfiniteScroll = _ref => {
  let {
    renderItems,
    onPageEnd,
    scrollAncestor,
    cursor,
    includeTopOffset
  } = _ref;
  const scrollableAncestor = scrollAncestor || (serverSide ? 'window' : window);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderItems(), /*#__PURE__*/_jsx(Waypoint, {
      bottomOffset: THRESHOLD,
      scrollableAncestor: scrollableAncestor,
      onEnter: onPageEnd,
      topOffset: includeTopOffset ? TOP_THRESHOLD : undefined
    }, cursor)]
  });
};

export default InfiniteScroll;